import React from 'react'
import { makeStyles } from '@mui/styles'

import lang from '@/lang'
import LinkIcon from '@assets/images/icons/assigned_horizontal.svg'
import { SquareIconButton } from '@/modules/base/components/buttons/index'
import PropTypes from 'prop-types'
import { CssHelper } from '@/modules/base/view/mixin/helpers_mixin'
import Badge from '@/modules/base/components/badge/badge'
import clsx from 'clsx'

const useStyles = makeStyles(theme => ({
  badge: {
    '& label': {
      fontSize: 11,
      lineHeight: '2.36',
      letterSpacing: '0.11px',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
    },
    marginRight: 'auto',
    padding: '2px 17px',
    borderRadius: '25px',
    height: '30px',
    overflow: 'hidden',
  },
  tooltip: {
    fontSize: 12,
    '& *': {
      fontSize: 12,
      textDecoration: 'none !important',
    },
  },
  button: {
    backgroundColor: theme.green,
    borderColor: (props) => props.readOnly ? theme.disabledColor : theme.green,
    '&:hover': {
      backgroundColor: CssHelper.important(theme.green),
    },
  },
}))

const AssignedBadge = (props) => {
  const { file } = props

  const classes = useStyles({ ...props })

  if (file) {
    return (
      <SquareIconButton
        className={classes.button}
        icon={LinkIcon}
        iconColor='white'
        customIconSize='20px'
        classes={{ tooltip: classes.tooltip }}
      />
    )
  }

  return (
    <Badge label={lang.file.list.isAssigned} color='green' icon={LinkIcon} iconFill='white' customClass={clsx(classes.badge, props.customClass)} />
  )
}

AssignedBadge.propTypes = {
  file: PropTypes.object,
  customClass: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  disabled: PropTypes.bool,
}

export default AssignedBadge
